import React, { useEffect, useState } from 'react';

function MainTop (props) {
  // gnb 상단 열리는 부분 핸들링 상태값
  const [hide, setHide] = useState(true);

  // 1depth 폴딩영역
  const [sbsSub, setSbsSub] = useState(true);
  const [historySub, setHistorySub] = useState(true);
  const [platformSub, setPlatformSub] = useState(true);

  // 1depth 유지해야하는 영역
  const [select1depPath, setSelect1depPath] = useState('');

  
  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/vision') {
      setSelect1depPath('sbsSub');
      document.getElementById('sbsSub').className = 'sbsabout_lnb_cont sub_current';
      document.getElementById('visionChildSub').className = 'lnb_sub_cont current';
    } else if (path === '/ci') {
      setSelect1depPath('sbsSub');
      document.getElementById('sbsSub').className = 'sbsabout_lnb_cont sub_current';
      document.getElementById('ciChildSub').className = 'lnb_sub_cont current';
    } else if (path === '/history_graph') {
      setSelect1depPath('sbsSub');
      document.getElementById('sbsSub').className = 'sbsabout_lnb_cont sub_current';
      document.getElementById('history_graphChildSub').className = 'lnb_sub_cont current';
    } else if (path === '/report') {
      setSelect1depPath('sbsSub');
      document.getElementById('sbsSub').className = 'sbsabout_lnb_cont sub_current';
      document.getElementById('reportChildSub').className = 'lnb_sub_cont current';
    } else if (path === '/history') {
      setSelect1depPath('historySub');
      document.getElementById('historySub').className = 'sbsabout_lnb_cont sub_current';
      document.getElementById('historyChildSub').className = 'lnb_sub_cont current';
    } else if (path === '/program') {
      setSelect1depPath('historySub');
      document.getElementById('historySub').className = 'sbsabout_lnb_cont sub_current';
      document.getElementById('programChildSub').className = 'lnb_sub_cont current';
    } else if (path === '/platform') {
      setSelect1depPath('platformSub');
      document.getElementById('platformSub').className = 'sbsabout_lnb_cont sub_current';
      document.getElementById('platformChildSub').className = 'lnb_sub_cont current';
    }
  }, []);

  // sbsSub 열리는 부분
  useEffect(() => {
    if (sbsSub === false) {
      // 해당 영역은 상단 페이지 마우스 들어올때 초기 열리는 로직부(초기화 한번 해줌 해당 위치에 맞게)
      // 하단 열리는 부분 제어문 추가
      document.getElementById('sbsabout_lnb_sub_sbs').style.display = 'block';
      document.getElementById('sbsabout_lnb_sub_history').style.display = 'none';
      document.getElementById('sbsabout_lnb_sub_platform').style.display = 'none';

      const path = window.location.pathname;
      if (path !== '/') {
        document.getElementById(select1depPath).className = 'sbsabout_lnb_cont sub_current';
      }
    }
  }, [sbsSub]);

  // historySub 열리는 부분
  useEffect(() => {
    if (historySub === false) {
      // 해당 영역은 상단 페이지 마우스 들어올때 초기 열리는 로직부(초기화 한번 해줌 해당 위치에 맞게)
      // 하단 열리는 부분 제어문 추가
      document.getElementById('sbsabout_lnb_sub_sbs').style.display = 'none';
      document.getElementById('sbsabout_lnb_sub_history').style.display = 'block';
      document.getElementById('sbsabout_lnb_sub_platform').style.display = 'none';

      const path = window.location.pathname;
      if (path !== '/') {
        document.getElementById(select1depPath).className = 'sbsabout_lnb_cont sub_current';
      }
    }
  }, [historySub]);

  // platformSub 열리는 부분
  useEffect(() => {
    if (platformSub === false) {
      // 해당 영역은 상단 페이지 마우스 들어올때 초기 열리는 로직부(초기화 한번 해줌 해당 위치에 맞게)
      // 하단 열리는 부분 제어문 추가
      document.getElementById('sbsabout_lnb_sub_sbs').style.display = 'none';
      document.getElementById('sbsabout_lnb_sub_history').style.display = 'none';
      document.getElementById('sbsabout_lnb_sub_platform').style.display = 'block';

      const path = window.location.pathname;
      if (path !== '/') {
        document.getElementById(select1depPath).className = 'sbsabout_lnb_cont sub_current';
      }
    }
  }, [platformSub]);

  // TODO 해당 로직 검토해보기
  useEffect(() => {
    try {
      const path = window.location.pathname;
      if (path !== '/') {
        document.getElementById(select1depPath).className = 'sbsabout_lnb_cont sub_current';
      }
    } catch (error) {

    }
  }, [hide]);

  return (
    <div id='header' className={`header_wrap ${hide ? '' : 'gnb_open'}`} onKeyDown={() => { setHide(true); }} onMouseLeave={() => { setHide(true); }}>
      <div className='sbsabout_inner'>
        <h1 className='sbsabout_logo_w'>
          <a href='/' className='sbsabout_logo_link'>
            <span className='svg_icon_aboutsbs'>
              <svg width='104' height='18' viewBox='0 0 102.999 18'>
                <g id='aboutsbs_logo_b' transform='translate(0 0)'>
                  <path id='about' d='M13.321,2.458a1.776,1.776,0,0,1-.925-.2,1.357,1.357,0,0,1-.507-.831L10.7-2.441H4.024L2.834,1.447a1.165,1.165,0,0,1-1.19,1.011H-.14L5.456-14.6l2.379-.09a2.132,2.132,0,0,1,1.344.337,2.073,2.073,0,0,1,.815,1.146l5.2,15.663ZM4.751-4.756H9.972L7.7-12.149H7.042ZM23.434-3.722A8.447,8.447,0,0,0,23.3-5.25a4.347,4.347,0,0,0-.419-1.258,2.332,2.332,0,0,0-.749-.854,1.951,1.951,0,0,0-1.124-.315,2.081,2.081,0,0,0-1.542.652A2.793,2.793,0,0,0,18.829-5V.413a2,2,0,0,0,.826.258,7.313,7.313,0,0,0,1,.079A2.131,2.131,0,0,0,21.913.379a2.891,2.891,0,0,0,.87-.989,4.785,4.785,0,0,0,.5-1.427A8.985,8.985,0,0,0,23.434-3.722ZM16.3-13.07q0-.472-.044-.944a5.162,5.162,0,0,0-.154-.876,5.847,5.847,0,0,1,.936-.3,4.294,4.294,0,0,1,1.024-.146.676.676,0,0,1,.606.247,1.346,1.346,0,0,1,.165.742v5.506a2.762,2.762,0,0,1,1.157-.584,5.756,5.756,0,0,1,1.6-.225A3.976,3.976,0,0,1,24.877-8.1,7.007,7.007,0,0,1,26.1-3.677a8.171,8.171,0,0,1-.375,2.528,6.028,6.028,0,0,1-1.069,2,4.957,4.957,0,0,1-1.7,1.326A5.135,5.135,0,0,1,20.7,2.66a9.486,9.486,0,0,1-2.567-.3,5.5,5.5,0,0,1-1.84-.888ZM27.509-3.677a8.532,8.532,0,0,1,.364-2.584,5.734,5.734,0,0,1,1.035-1.955,4.443,4.443,0,0,1,1.63-1.236,5.279,5.279,0,0,1,2.17-.427,5.092,5.092,0,0,1,2.192.461,4.727,4.727,0,0,1,1.663,1.292,5.847,5.847,0,0,1,1.046,2,8.672,8.672,0,0,1,.364,2.584A8.45,8.45,0,0,1,37.611-.98,5.628,5.628,0,0,1,36.564.975,4.608,4.608,0,0,1,34.9,2.222a5.314,5.314,0,0,1-2.192.438,4.947,4.947,0,0,1-2.17-.461A4.677,4.677,0,0,1,28.908.907a5.96,5.96,0,0,1-1.035-2A8.672,8.672,0,0,1,27.509-3.677Zm2.6-.022A7.765,7.765,0,0,0,30.3-1.947a5.145,5.145,0,0,0,.529,1.4,2.817,2.817,0,0,0,.826.933,1.848,1.848,0,0,0,1.08.337A2.189,2.189,0,0,0,34.692-.43,5.949,5.949,0,0,0,35.4-3.542a6.136,6.136,0,0,0-.705-3.146,2.18,2.18,0,0,0-1.961-1.191,2.186,2.186,0,0,0-1.906,1.09A5.613,5.613,0,0,0,30.109-3.7Zm19.5,4.787a3.944,3.944,0,0,1-.98.674,6.546,6.546,0,0,1-1.267.472,10.682,10.682,0,0,1-1.41.27,11.326,11.326,0,0,1-1.388.09,6.149,6.149,0,0,1-1.851-.27,4.166,4.166,0,0,1-1.487-.809A3.8,3.8,0,0,1,40.232.166a4.569,4.569,0,0,1-.364-1.888V-7.475a8.136,8.136,0,0,0-.2-1.843q.176-.067.419-.146t.518-.146a4.734,4.734,0,0,1,.551-.1,4.119,4.119,0,0,1,.5-.034q.837,0,.837.989v7.169a1.913,1.913,0,0,0,.22.966,2.127,2.127,0,0,0,.54.629,2.1,2.1,0,0,0,.705.36A3.4,3.4,0,0,0,44.672.5a3.219,3.219,0,0,0,.595-.011q.33-.034.661-.09a3.727,3.727,0,0,0,.617-.157,1.362,1.362,0,0,0,.419-.213V-7.475a8.135,8.135,0,0,0-.055-.944,6.711,6.711,0,0,0-.165-.9q.176-.067.43-.146t.54-.146a5.221,5.221,0,0,1,.562-.1,4.119,4.119,0,0,1,.5-.034.862.862,0,0,1,.661.236.954.954,0,0,1,.176.753Zm3.04-11.6q0-.472-.022-.8a1.778,1.778,0,0,0-.154-.618,7.08,7.08,0,0,1,1.035-.393,3.431,3.431,0,0,1,.947-.146.7.7,0,0,1,.584.191,1.248,1.248,0,0,1,.143.708v1.91h3.062v1.169a.986.986,0,0,1-.253.753,1.191,1.191,0,0,1-.826.236H55.181V-.643a1.194,1.194,0,0,0,.253.809.9.9,0,0,0,.76.27,4.368,4.368,0,0,0,.694-.079,4.152,4.152,0,0,0,.694-.169.793.793,0,0,1,.683.034.88.88,0,0,1,.375.64l.22,1.079a2.574,2.574,0,0,1-.573.292,5.661,5.661,0,0,1-.738.225q-.386.09-.771.146a4.635,4.635,0,0,1-.65.056,7.368,7.368,0,0,1-1.487-.135,2.16,2.16,0,0,1-1.091-.562A2.718,2.718,0,0,1,52.878.772a7.288,7.288,0,0,1-.231-2.045v-6.18h-1.52v-2.2h1.52Z' transform='translate(0.14 15.34)' fill='#bfbfbf' />
                  <path id='sbs' d='M9.486,8.465C8.98,7.76,4.68,4.532,4.879,3.523c-.064-2.4,4.8-1.2,6.1-1.472V.024h-7a3.839,3.839,0,0,0-2.93,6.444L5.92,11.179a1.541,1.541,0,0,1,.534,1.611c-.419,1.765-5.51.748-6.454,1V17.9H6.769c5.175.071,6.53-6.658,2.717-9.439m27.334,0c-.505-.705-4.806-3.934-4.608-4.941-.064-2.405,4.8-1.2,6.1-1.472V.024h-7a3.839,3.839,0,0,0-2.931,6.444l4.876,4.712a1.547,1.547,0,0,1,.535,1.611c-.424,1.765-5.511.748-6.457,1V17.9H34.1c5.175.071,6.53-6.658,2.72-9.439M22.872,7.677C28.011,5.663,25.1-.6,20.784.047l0,0H13.058l0,17.859c1.133-.383,8.908,1.046,11.561-1.22,2.849-2.458,2.187-7.722-1.749-9M17.236,2.086c1.44.22,3.647-.829,4.236,1.932.393,2.444-2.91,2.345-4.236,2.252Zm2.23,11.709h-2.23V9.037H19.38c2.744-.452,4.072,4.572.087,4.757' transform='translate(63.999 0)' fill='#fff' />
                </g>
              </svg>
              <i className='hide'>About SBS</i>
            </span>
          </a>
        </h1>

        <div className='sbsabout_lnb_w'>
          <ul className='sbsabout_lnb_inner' onKeyUp={() => { setHide(false); }} onKeyDown={() => { setHide(true); }} onMouseEnter={() => { setHide(false); }} onMouseLeave={() => { setHide(true); }}>

            <li id='sbsSub' className='sbsabout_lnb_cont' onKeyUp={() => { setSbsSub(false); }} onKeyDown={() => { setSbsSub(true); }} onMouseEnter={() => { setSbsSub(false); }} onMouseLeave={() => { setSbsSub(true); }}>
              <a href='#none' className='sbsabout_lnb_link'>
                <span className='sbsabout_lnb_text'>SBS</span>
              </a>

              <div className='sbsabout_lnb_sub' id='sbsabout_lnb_sub_sbs'>
                <ul className='lnb_sub_list'>
                  <li id='visionChildSub' className='lnb_sub_cont'>
                    {/* <Link href='/vision'> */}
                      <a className='lnb_sub_link' href='/vision'>비전</a>
                    {/* </Link> */}
                  </li>
                  <li id='ciChildSub' className='lnb_sub_cont'>
                    {/* <Link href='/ci'> */}
                      <a href='/ci' className='lnb_sub_link'>CI</a>
                    {/* </Link> */}
                  </li>
                  <li id='history_graphChildSub' className='lnb_sub_cont'>
                    {/* <Link href='/history_graph'> */}
                      <a href='/history_graph' className='lnb_sub_link'>연혁</a>
                    {/* </Link> */}
                  </li>
                  <li id='reportChildSub' className='lnb_sub_cont'>
                    {/* 해당 보도자료 부분은 react 에서 관리된는 spa타면 안되어서 link 태그 걷어내고 사용 */}
                      <a href='/report' className='lnb_sub_link'>보도자료</a>
                  </li>
                </ul>
              </div>
            </li>

            <li id='historySub' className={`sbsabout_lnb_cont ${historySub ? '' : 'sub_current'}`} onKeyUp={() => { setHistorySub(false); }} onKeyDown={() => { setHistorySub(true); }} onMouseEnter={() => { setHistorySub(false); }} onMouseLeave={() => { setHistorySub(true); }}>
              <a href='#none' className='sbsabout_lnb_link'>
                <span className='sbsabout_lnb_text'>History</span>
              </a>

              <div className='sbsabout_lnb_sub' id='sbsabout_lnb_sub_history'>
                <ul className='lnb_sub_list'>
                  <li id='historyChildSub' className='lnb_sub_cont'>
                    {/* <Link href='/history'> */}
                      <a href='/history' className='lnb_sub_link'>역사</a>
                    {/* </Link> */}
                  </li>
                  <li id='programChildSub' className='lnb_sub_cont'>
                    {/* <Link href='/program'> */}
                      <a href='/program' className='lnb_sub_link'>대표 프로그램</a>
                    {/* </Link> */}
                  </li>
                </ul>
              </div>
            </li>

            <li id='platformSub' className={`sbsabout_lnb_cont ${platformSub ? '' : 'sub_current'}`} onKeyUp={() => { setPlatformSub(false); }} onKeyDown={() => { setPlatformSub(true); }} onMouseEnter={() => { setPlatformSub(false); }} onMouseLeave={() => { setPlatformSub(true); }}>
              <a href='#none' className='sbsabout_lnb_link'>
                <span className='sbsabout_lnb_text'>Platform</span>
              </a>

              <div className='sbsabout_lnb_sub' id='sbsabout_lnb_sub_platform'>
                <ul className='lnb_sub_list'>
                  <li id='platformChildSub' className='lnb_sub_cont'>
                    {/* <Link href='/platform'> */}
                      <a href='/platform' className='lnb_sub_link'>플랫폼 소개</a>
                    {/* </Link> */}
                  </li>
                </ul>
              </div>
            </li>

          </ul>
        </div>

        {/* <Link href="https://www.sbs.co.kr?div=gnb_pc"> */}
          <a href="https://www.sbs.co.kr?div=gnb_pc" className='sbsabout_link_other'>
            <span className='link_other_text'>SBS Site</span>
            <span className='svg_icon_up_right'>
              <svg width='9' height='9' viewBox='0 0 9 9'>
                <g id='arrow-up-right' transform='translate(3.5 -12.5)'>
                  <path id='path_385' data-name='path 385' d='M11.088,18.5a.588.588,0,0,1-.416-1L18.5,9.672a.588.588,0,0,1,.832.832L11.5,18.328A.586.586,0,0,1,11.088,18.5Z' transform='translate(-14 3)' fill='#333' />
                  <path id='path_386' data-name='path 386' d='M18.912,17.5a.588.588,0,0,1-.588-.588V10.676H12.088a.588.588,0,1,1,0-1.176h6.824a.588.588,0,0,1,.588.588v6.824A.588.588,0,0,1,18.912,17.5Z' transform='translate(-14 3)' fill='#333' />
                </g>
              </svg>
            </span>
          </a>
        {/* </Link> */}
      </div>
    </div>
  );
}

export default MainTop;
